import {
  BookMarked,
  BookOpen,
  Brain,
  Briefcase,
  ClipboardList,
  FlaskConical,
  Folder,
  GraduationCap,
  Landmark,
  Leaf,
  Stethoscope,
  type LucideIcon,
} from 'lucide-react';

export const COURSE_FOLDER_ICONS: Array<{ key: string; label: string; icon: LucideIcon }> = [
  { key: 'folder', label: 'Folder', icon: Folder },
  { key: 'book-open', label: 'Open book', icon: BookOpen },
  { key: 'bookmarked', label: 'Study notes', icon: BookMarked },
  { key: 'graduation-cap', label: 'Graduation', icon: GraduationCap },
  { key: 'stethoscope', label: 'Clinical', icon: Stethoscope },
  { key: 'clipboard-list', label: 'Checklist', icon: ClipboardList },
  { key: 'landmark', label: 'Civil services', icon: Landmark },
  { key: 'brain', label: 'Revision', icon: Brain },
  { key: 'briefcase', label: 'Career', icon: Briefcase },
  { key: 'flask', label: 'Research', icon: FlaskConical },
  { key: 'leaf', label: 'Ayurveda', icon: Leaf },
];

export function courseFolderIcon(key?: string): LucideIcon {
  return COURSE_FOLDER_ICONS.find((option) => option.key === key)?.icon ?? Folder;
}

export function courseFolderIds(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter((id): id is string => typeof id === 'string' && id.length > 0);
}
